/**
 * AutoCount - Create Order Page
 */

import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";

import { useNavigate } from "react-router-dom";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

function OrdersCreate(): JSX.Element {
  const navigate = useNavigate();
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={8}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Create New Order
                </MDTypography>
              </MDBox>
              <MDBox p={3}>
                <MDTypography variant="h6" mb={2}>Customer Information</MDTypography>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <MDInput label="Customer Name *" fullWidth />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <MDInput label="Email" fullWidth />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <MDInput label="Phone" fullWidth />
                  </Grid>
                </Grid>

                <Divider sx={{ my: 3 }} />

                <MDTypography variant="h6" mb={2}>Shipping Address</MDTypography>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <MDInput label="Address" fullWidth />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <MDInput label="City" fullWidth />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <MDInput label="State" fullWidth />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <MDInput label="ZIP Code" fullWidth />
                  </Grid>
                </Grid>

                <Divider sx={{ my: 3 }} />

                <MDTypography variant="h6" mb={2}>Order Items</MDTypography>
                <MDTypography variant="body2" color="text">
                  Search and add parts to this order.
                </MDTypography>
                <MDBox mt={2}>
                  <MDInput label="Search Parts" fullWidth placeholder="Enter part number or name..." />
                </MDBox>
                <MDBox mt={2}>
                  <MDButton variant="outlined" color="info">Add Item</MDButton>
                </MDBox>
              </MDBox>
            </Card>
          </Grid>

          <Grid item xs={12} lg={4}>
            <Card>
              <MDBox p={3}>
                <MDTypography variant="h6" mb={2}>Order Summary</MDTypography>
                <MDBox mb={2} display="flex" justifyContent="space-between">
                  <MDTypography variant="body2">Subtotal:</MDTypography>
                  <MDTypography variant="body2" fontWeight="medium">$0.00</MDTypography>
                </MDBox>
                <MDBox mb={2} display="flex" justifyContent="space-between">
                  <MDTypography variant="body2">Tax:</MDTypography>
                  <MDTypography variant="body2" fontWeight="medium">$0.00</MDTypography>
                </MDBox>
                <MDBox mb={2} display="flex" justifyContent="space-between">
                  <MDTypography variant="body2">Shipping:</MDTypography>
                  <MDTypography variant="body2" fontWeight="medium">$0.00</MDTypography>
                </MDBox>
                <Divider />
                <MDBox mt={2} display="flex" justifyContent="space-between">
                  <MDTypography variant="h6">Total:</MDTypography>
                  <MDTypography variant="h6" color="info">$0.00</MDTypography>
                </MDBox>
                <MDBox mt={3}>
                  <MDButton
                    variant="gradient"
                    color="success"
                    fullWidth
                    onClick={() => navigate("/orders")}
                  >
                    Create Order
                  </MDButton>
                </MDBox>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default OrdersCreate;
